import axios from "axios";
import { SuperAdminURL } from "../../../../config/UrlEndPoint";

export const URL = `${SuperAdminURL}access_role`;

export function findAccessRole(queryParams) {
  return axios.post(`${URL}/find`, queryParams);
}
export function findAccessRoleById(id) {
  return axios.get(`${URL}/${id}`);
}
export function createAccessRole(payload) {
  return axios.post(`${URL}/create`, payload);
}
export function updateAccessRole(payload) {
  return axios.put(`${URL}/update`, payload);
}
export function deleteAccessRoleFolder(id) {
  return axios.delete(`${URL}/delete_folder/${id}`);
}
export function findMasterRole() {
  return axios.get(`${URL}/master_role`);
}
